module.exports = __webpack_public_path__ + "static/media/10-lightbox.ec298b73.png";